export default __webpack_public_path__ + "static/media/Refresh.2dcba44e.svg";